import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router';
import { connect, useDispatch } from 'react-redux';
import { Button, Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { getMlps, getMlp, postMlp, putMlp } from '../../store/actions/mlp/mlp_action';
import { REACT_ROUTES } from '../../constants/react_routes';
import history from '../../services/history';
import TextInput from '../ui_components/text_input';
import { useSnackbar } from 'notistack';
import { todayAndTomorrow } from '../../utils/helper_functions';
import Autocomplete from '../ui_components/autocomplete';
import DatePicker from '../ui_components/datepicker_controller';
import { isValid } from 'date-fns';
import { API_PREFIX as API, API_ROUTES } from '../../constants/api_routes';

const useStyles = makeStyles((theme) => ({
	container: {
		padding: theme.spacing(3, 2)
	},
    typography: {
		margin: theme.spacing(3, 0, 2)
    },
    form: {
		width: '100%', // Fix IE 11 issue.
		marginTop: theme.spacing(1),
        '& p': {
            color: '#bf1650',
            '&::before': {
                display: 'inline',
                content: '"⚠ "'
            }
        }
	}
}));

const Mlp = ({ mlps }) => {
    const { uuid } = useParams();
    const { today } = todayAndTomorrow();
    const { container, typography, form } = useStyles();
    const { control, handleSubmit, setValue, formState: { errors } } = useForm();
    const dispatch = useDispatch();
    const [date, setDate] = useState(null);
    const [customer, setCustomer] = useState(null);

    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        uuid && (async () => {
            const mlp = await getMlp(uuid);
            if(mlp?.customer) {
                setCustomer(mlp.customer);
            }
            if(mlp?.date) {
                setDate(mlp.date);
            }
            for (const key in mlp) {
                setValue(key, mlp[key]);
            }
        })();
        !mlps.collection.length && dispatch(getMlps());
    }, [uuid]);

    useEffect(() => {
        setDate(today);
        setValue('date', today);
    }, [])

    const onSubmit = (data) => {
        data.duration = data?.duration && parseInt(data.duration);
        if (uuid) {
            enqueueSnackbar(
                'Uspešno sačuvan MLP', {
                variant: 'success'
            });
            return dispatch(putMlp(uuid, data));
        }
        enqueueSnackbar(
            'Uspešno dodat MLP', {
            variant: 'success'
        });
        return dispatch(postMlp(data));
    }

    const handleClickBackToList = () => {
        history.push(REACT_ROUTES.MLPS);
    }

    const handleCustomerObject = (object) => {
        const customer = object ? (object?.['@id'] || `${API}${API_ROUTES.CUSTOMERS}/${object?.uuid}`) : null;
        setCustomer(customer);
        setValue('customer', customer);
    }

    const handleDateChange = (e) => {
        setDate(e);
        setValue('date', e);
    }

    return (
        <Container className={container}>
            <Typography align="center" variant="h4" className={typography}>MLP</Typography>
            <Grid container justify="center" spacing={3}>
                <Grid item>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        onClick={handleSubmit(onSubmit)}
                        type="button"
                    >
                        Sačuvaj
                    </Button>
                </Grid>
                <Grid item>
                    <Button
                        variant="contained"
                        size="small"
                        color="primary"
                        onClick={handleClickBackToList}
                    >
                        Nazad
                    </Button>
                </Grid>
            </Grid>
            <form className={form}>
                <Grid container justify="center" spacing={3}>
                    <Grid item xs={8}>
                        <Autocomplete
                            name="customer"
                            control={control}
                            rules={{ required: 'Unesite Klijenta' }}
                            api={API_ROUTES.CUSTOMERS}
                            label="Klijent"
                            handleObject={handleCustomerObject}
                            preloadValue={customer}
                        />
                        <ErrorMessage errors={errors} name="customer" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            name="amount"
                            label="Iznos"
                            control={control}
                        />
                    </Grid>
                    <Grid item xs={8}>
                        <DatePicker
                            name="date"
                            control={control}
                            rules={{ required: 'Unesite datum', validate: date => isValid(new Date(date)) || 'Nepravilan datum' }}
                            label="Datum"
                            value={date}
                            onChange={handleDateChange}
                        />
                        <ErrorMessage errors={errors} name="date" as="p" />
                    </Grid>
                    <Grid item xs={8}>
                        <TextInput
                            name="description"
                            control={control}
                            label="Opis"
                            multiline
                            rows={4}
                            variant="outlined"
                        />
                    </Grid>
                </Grid>
            </form>
        </Container>
    )
}

Mlp.propTypes = {
    mlps: PropTypes.object
}

const mapStateToProps = (state) => ({
    mlps: state.mlps
});

export default connect(mapStateToProps)(Mlp);
